import { message } from "antd";

const hardcodeToken = "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiJiZWEwODRmMS1iOWI0LTQ2ZGEtYjZiZi1kNDg1YjE2YWJjZGQiLCJuYW1lIjoiQXJlZWogWmFoaWQgQWxpIiwiaW1hZ2UiOiJodHRwczovL3dvcmt3LmNvbS9SZXNvdXJjZXNcXDBhYjVmOWMwLWY5NDgtNGM0MC04ZGFkLWM1OGJhOTlmYjc2NVxcSW1hZ2VzXFxiZGM2YmM1NC0wNjAwLTQxOGYtYTM0OS1mMDIyMWRhYjU2MGYuanBlZyIsImVtYWlsIjoiYXJlZWpAbWlsZXRhcC5jb20iLCJidXNpbmVzc0lkIjoiMGFiNWY5YzAtZjk0OC00YzQwLThkYWQtYzU4YmE5OWZiNzY1IiwidmVyIjoiODIzODlFQkMtMDA1OS00NEUzLUI1QjUtMUM0REU0NzcwQ0E1IiwiaWgiOiJ2U0ZDM1daRmx5bXhvREQvdmV0dmZUN2d1N09PZ0VrZmxDdGhObzVsWjc4PSIsImlzIjoiOHU1QlZFbkcrUlBLR3gvSVpDYmJKUT09IiwicGgiOiJsTWRsdDR1TGtIRWF2S2ZwTXJWTFpaRG1ZaHc4RTdQbU1BdGs0M0JZSVhJPSIsInBzIjoiU1NUMm44QkFlSEZrOVRhS0N0QUM1Zz09IiwiaXNBZ2VudCI6IkZhbHNlIiwianRpIjoiNTQ4Y2RiNDYtNTRhMS00MWI1LTkyZjEtMGFlNTc5YTE4NjAyIiwibmJmIjoxNzY5MjQ0NDI1LCJleHAiOjE3Njk0MTcyMjV9.Ju6YRmXtza1pT7nhsVw936PmgVEUMEyU2X6bOnmg2G7s3dcule1RWXfrx-mSt9xS4tcILakYG3RJP8pK62rOzRo8liVLKzGcZRd4BI5MzhWzCEsh6dxbFp6chPY9b9aTGsjO3YUCTR_CmHgfNFpJ98vsW60avk2Ywu7ihJC0BClkEc_aVk08fNRyWm-u_J-OoWYO1iz-Ou4nfGqD_fTjsy2RbzhG-ySyReE7sKA7eha3Hq4c4ET458uvzzLn3wBxbh7Xpx12FoiIxHHbla8vSDz_RTVhH6bfN07Cu97c5sCWtrQdF7iGWI2ulA_33VS0ydaqgbHS2Uk63BegHEdatA";

function getCookieValue(name) {
  const regex = new RegExp(`(^| )${name}=([^;]+)`)
  const match = document.cookie.match(regex)
  if (match) {
    return match[2]
  }
}

export function getWorkWiseAuthToken() {
  const searchParams = new URLSearchParams(document.location.search);
  let cookieToken = getCookieValue("token")
  let queryToken = searchParams.get("token");
  const finalToken = queryToken || cookieToken || hardcodeToken;
  return finalToken;
}

export function decodeWorkWiseToken() {
  const token = getWorkWiseAuthToken();
  if (!token) return null;
  try {
    const payload = token.split('.')[1];
    const decoded = JSON.parse(atob(payload));
    return decoded;
  } catch (error) {
    console.error('Error decoding token:', error);
    return null;
  }
}

export function getSelectedData(sheet, selectedRange) {
  const { sri, sci, eri, eci } = selectedRange;
  const data = [];
  const headers = [];
  for (let ci = sci; ci <= eci; ci += 1) {
    const column = [];
    for (let ri = sri; ri <= eri; ri += 1) {
      const cell = sheet.data.getCell(ri, ci);
      const cellData = cell && typeof cell.text === 'string' ? cell.text.trim() : null;
      if (ri === sri) {
        headers.push(cellData || "");
        column.push(cellData || "");
      } else {
        column.push(cellData || "");
      }
    }
    if (column.length > 0) {
      data.push(column);
    }
  }
  let payload = {
    data: data,
    headers: headers
  }
  return payload;
}

export function findSheetName(sheets, text) {

  const sheetNames = sheets.map((sheet) => sheet.name);

  let maxCount = 0;
  const names = sheetNames && Array.isArray(sheetNames) && sheetNames.filter(name => name && name.includes(text));

  const counts = names.map(name => {
    const match = name.match(new RegExp(`${text} (\\d+)`));
    return match ? parseInt(match[1], 10) : 0;
  });

  maxCount = counts && Math.max(...counts);
  console.log('okkkk names', sheetNames, sheets, counts);

  let name = maxCount >= 0 ? `${text} ${maxCount + 1}` : `${text} 0`;

  return name;
}
export const formatFileSize = (bytes) => {
  if (bytes === 0) return "0 Bytes";

  const units = ["Bytes", "KB", "MB", "GB"];
  let size = bytes;
  let unitIndex = 0;

  while (size >= 1024 && unitIndex < units.length - 1) {
    size /= 1024;
    unitIndex++;
  }

  if (unitIndex === 0) {
    return `${size} ${units[unitIndex]}`;
  } else if (unitIndex === 1 && size < 50) {
    return `${parseFloat(size.toFixed(0))} ${units[unitIndex]}`;
  } else {
    return `${parseFloat(size.toFixed(2))} ${units[unitIndex]}`;
  }
};
export const getWatermarkData = async () => {
  const now = new Date();
  const currentDateTime = now.toLocaleString();

  // Get IP address
  let ip = 'N/A';
  try {
    const response = await fetch('https://api.ipify.org?format=json');
    const data = await response.json();
    ip = data.ip;
  } catch (error) {
    console.error("Error fetching IP:", error);
    message.error("Could not fetch IP address");
  }

  // Get location
  let location = { lat: 'N/A', lng: 'N/A' };
  try {
    location = await new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        message.error("Geolocation not supported");
        return resolve(location);
      }

      navigator.geolocation.getCurrentPosition(
        (position) => resolve({
          lat: position.coords.latitude,
          lng: position.coords.longitude
        }),
        (error) => {
          handleGeolocationError(error);
          resolve(location); // Return default on error
        }
      );
    });
  } catch (error) {
    console.error("Location error:", error);
  }

  return {
    currentDateTime,
    ip,
    location
  };
};

const handleGeolocationError = (error) => {
  switch (error.code) {
    case error.PERMISSION_DENIED:
      message.error("Location access denied. Please enable permissions.");
      break;
    case error.POSITION_UNAVAILABLE:
      message.error("Location information unavailable.");
      break;
    case error.TIMEOUT:
      message.error("Location request timed out.");
      break;
    default:
      message.error("Unknown location error occurred.");
  }
};
